import kr from '../kr/kr';
import Swiper from 'swiper/bundle'

export default class FireplacesSlider extends kr.Component {
    init() {
        this._slider = null;
        this.els = {
            bind: this.$element.querySelector('.js_bind'),
            nav_prev: this.$element.querySelector('.js_bind-nav-prev'),
            nav_next: this.$element.querySelector('.js_bind-nav-next'),
        }

        this.bind();
    }
    bind() {

        this._slider = new Swiper(this.els.bind, {
            loop: false,
            slidesPerView: 1,
            loopedSlides: 1,
            spaceBetween: 20,
            watchSlidesVisibility: true,
            navigation: {
              nextEl: this.els.nav_next,
              prevEl: this.els.nav_prev ,
            },
            breakpoints: {
                // when window width is >= 480px
                1100: {
                  slidesPerView: 2
                },
                // when window width is >= 640px
                1400: {
                  slidesPerView: 3,
                }
            }
        });

        this.$element.parentNode.parentNode.parentNode.addEventListener('mouseenter', () => {
            this._slider.update();
            
        });
    }
}

kr.registerComponent('.js_our-fireplaces-slider', {
    component: FireplacesSlider
});